// @ts-nocheck
/* eslint-disable */
export const appMinus32Icon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none"><path d="M21.5 15.5L10.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`,
    name: 'minus-32' as const
};